import type { CountrySiteName } from '@seek/melways-sites';

export const SERVER_SIDE_AUTH_COOKIE_NAME = 'ENABLE_CHALICE_SSA';

export const releasedSSASites: CountrySiteName[] = [];
